{
  "global": {
    "signedUp": "påmeldt",
    "signedUpPlural": "påmeldte",
    "signUp": "Påmeld",
    "optOut": "Ta ut",
    "youAreSignedUp": "Du er nå meldt på",
    "youOptedOut": "Du er nå meldt av",
    "youAreLoggedIn": "Du er nå logget inn",
    "logOut": "Logg ut",
    "signingUp": "melde deg på",
    "optingOut": "melde deg av",
    "today": "idag",
    "dateDisplayAbbr": "d.",
    "timeOfDayAbbr": "kl",
    "now": "nå",
    "showToday": "Vis i dag",
    "showAll": "Åpne alle",
    "showProfile": "Vis profil",
    "choose": "Velg",
    "startDate": "Startdato",
    "startTime": "Starttid",
    "starts": "Starter",
    "started": "Underveis",
    "startedAlready": "Startet",
    "cancelled": "Avlyst",
    "duration": "Varighet",
    "endTime": "Sluttid",
    "endDate": "Sluttdato",
    "timeTo": "Om",
    "day": "dag",
    "days": "dager",
    "hour": "time",
    "hours": "timer",
    "hoursAbbr": "t.",
    "minutes": "min.",
    "tomorrow": "i morgen",
    "location": "sted",
    "document": "dokument",
    "documents": "Dokumenter",
    "images": "Bilder",
    "imagesAndVideos": "Bilder og videoer",
    "additionalProfiles": "flere",
    "passedDeadline": "Steng for av og påmelding",
    "close": "Lukk",
    "completed": "Ferdig",
    "fromDate": "Fra",
    "toDate": "Til",
    "date": "Dato",
    "oclock": "Klokka",
    "week": "Uke",
    "thisWeek": "Denne uken",
    "goToThisWeek": "Gå til denne uka",
    "goToToday": "Gå til i dag",
    "all": "alle",
    "seeAll": "se alle",
    "remaining": "De øvrige",
    "participate": "deltaker",
    "participantsPlural": "deltaker | deltakere",
    "participants": "Deltakere",
    "responsible": "Ansvarlige",
    "responsiblePlural": "ansvarlig | ansvarlige",
    "signUpDeadline": "På/afmeldingsfristen om",
    "signUpExpired": "Påmeldingsfristen har utløpt",
    "maxSignupsReached": "Ingen plasser igjen",
    "readMore": "Les mer",
    "genitive": "s",
    "nothingToShow": "Ingenting å vise",
    "waitingForResponse": "Venter på svar...",
    "tts": "les opp",
    "startButton": "start",
    "backButton": "Tilbake",
    "backTo": "Tilbake til",
    "errorOccured": "Det har oppstått en feil. Vennligst prøv igjen...",
    "weekdayMonday": "Mandag",
    "weekdayTuesday": "Tirsdag",
    "weekdayWednesday": "Onsdag",
    "weekdayThursday": "Torsdag",
    "weekdayFriday": "Fredag",
    "weekdaySaturday": "Lørdag",
    "weekdaySunday": "Søndag",
    "weekdayMondayAbbr": "Man",
    "weekdayTuesdayAbbr": "Tir",
    "weekdayWednesdayAbbr": "Ons",
    "weekdayThursdayAbbr": "Tor",
    "weekdayFridayAbbr": "Fre",
    "weekdaySaturdaydayAbbr": "Lør",
    "weekdaySunddayAbbr": "Søn",
    "MONDAY": "Mandag",
    "TUESDAY": "Tirsdag",
    "WEDNESDAY": "Onsdag",
    "THURSDAY": "Torsdag",
    "FRIDAY": "Fredag",
    "SATURDAY": "Lørdag",
    "SUNDAY": "Søndag",
    "autoplay": "Autoplay",
    "stop": "Stopp",
    "play": "Spill",
    "pause": "Pause",
    "restart": "Restart",
    "cancel": "Avbryt",
    "description": "Beskrivelse",
    "error": "Feil",
    "tryAgain": "Prøv igjen",
    "obs": "Obs",
    "somethingWentWrong": "Noe gikk galt",
    "nightShift": "Nattskift",
    "backToNow": "Tilbake til nå",
    "switchUser": "Bytt bruker",
    "noDescription": "Ingen beskrivelse",
    "about": "cirka",
    "busy": "Opptatt",
    "departments": "Avdelinger",
    "dishes": "Delretter",
    "employee": "Ansatt",
    "ends": "Slutter",
    "enterPinToAccess": "Skriv inn koden din for å få tilgang.",
    "error_suggestion": "Prøv igjen.",
    "galleries": "Gallerier",
    "info": "Info",
    "institution": "Institusjon",
    "lastUpdateMinutes": "Oppdatert {n} minutter siden",
    "loading": "Tenker...",
    "pictograms": "Piktogrammer",
    "repeats": "Gjentas",
    "reset": "Nullstill",
    "resident": "Beboer",
    "selectDepartment": "Skifte avdeling",
    "signupNotNeeded": "Påmelding ikke nødvendig",
    "sort": "Sorter visning",
    "stopAutoplay": "Stopp autoavspilling",
    "title": "Tittel",
    "uncategorized": "ukategorisert",
    "use": "Bruk",
    "videos": "Videoer"
  },
  "moduleNames": {
    "ACTIVITIES": "Aktiviteter",
    "BOOKING": "Booking",
    "EXTERNAL_ACTIVITIES": "Eksterne Aktiviteter",
    "GALLERY": "Galleri",
    "JOURNEY_PLANNER": "Reiseplan",
    "MEAL_PLAN": "Matplan",
    "MEETINGS": "Møter",
    "NEWS": "Nyheter",
    "OUR_HOME": "Hos oss",
    "SIMPLE_WORK_SCHEDULE": "Tjenesteplan",
    "WAYFINDER": "Veiviser",
    "WEATHER": "Været",
    "WORK_SCHEDULE": "Tjenesteplan",
    "CALENDAR": "Kalender",
    "BOOKING_ENTRY": "Booking",
    "BOOKING_RESOURCES": "Booking",
    "BOOKING_RESOURCE_ENTRY": "Booking"
  },
  "activities": {
    "moduleName": "Aktiviteter",
    "noActivities": "Ingen aktiviteter",
    "noActivitiesDescription": "Det finnes ingen aktiviteter...",
    "noVacancy": "Ingen plasser igjen",
    "vacation": "Ferier",
    "clubs": "Klubber",
    "noClubs": "Det finnes ingen klubber...",
    "optOut": "Skriv inn koden din for å melde deg av aktiviteten.",
    "optedOut": "Du er nå avmeldt fra aktiviteten.",
    "signUp": "Skriv inn koden din for å registrere deg for aktiviteten.",
    "signedUp": "Du er nå registrert for aktiviteten."
  },
  "externalActivities": {
    "moduleName": "Eksterne aktiviteter"
  },
  "activity": {
    "moduleName": "Aktivitet",
    "organizer": "Arrangert av",
    "price": "Pris",
    "currencyAbbr": "kr.",
    "responsible": "ansvarlig",
    "responsiblePlural": "ansvarlige",
    "noSeatsLeft": "Ingen plasser igjen",
    "oneSeatLeft": "sete igjen",
    "moreSeatsLeft": "seter igjen",
    "theActivity": "aktiviteten",
    "alreadySignedOff": "Du er ikke påmeldt denne aktiviteten",
    "alreadySignedUp": "Du er allerede påmeldt denne aktiviteten"
  },
  "booking": {
    "moduleName": "Booking",
    "moduleHeaderOverview": "Booking oversikt",
    "moduleHeaderResources": "Hva vil du booke?",
    "noBookings": "Det er ikke opprettet noen bookinger",
    "noResources": "Ingen bookings tilgjengelig ...",
    "inUseNow": "I bruk nå",
    "overview": "Oversikt",
    "newBooking": "Ny booking",
    "book": "book",
    "errorTimeSetting": "Tidsinnstillingsfeil. Startdato/klokkeslett passerer sluttdato/tid.",
    "ressourceNotAvailable": "Ressursen er ikke tilgjengelig i valgt tidsrom. Prøv igjen…",
    "ressourceNoLongerAvailable": "Ressursen er ikke lenger ledig. Prøv igjen...",
    "chooseParticipants": "Velg minst én person, og trykk deretter på lagre",
    "bookingCreated": "Bookingen er opprettet",
    "bookingDeleted": "Bookingen er slettet",
    "deletingBooking": "slette bookingen",
    "returnToBooking": "Tilbake til booking",
    "action": "booke",
    "addDescription": "Legg til en beskrivelse?",
    "selectParticipantsTitle": "Med hvem?",
    "selecttParticipantsDescription": "Velg minst én person, og trykk deretter på lagre",
    "toBook": "booke",
    "theBooking": "bookingen",
    "doubleBooking": "Oops, du er i ferd med å dobbeltbestille.",
    "chooseDifferentTime": "Vennligst velg en annen tid for bestillingen din.",
    "confirmBooking": "Bekreft booking",
    "allBookings": "Alle bestillinger",
    "bookResource": "Skriv inn koden din for å bestille",
    "cancelBooking": "Skriv inn koden din for å avbryte bestillingen.",
    "completed": "Bestillingen er fullført.",
    "existingBookings": "Eksisterende bookinger",
    "noSchema": "Ingen skjema opprettet",
    "times": "Tider"
  },
  "documents": {
    "moduleName": "Dokumenter",
    "noDocuments": "Det er ingen dokumenter å vise"
  },
  "employee": {
    "workingNow": "På jobb nå!",
    "working": "På jobb"
  },
  "gallery": {
    "moduleName": "Galleri",
    "noGalleries": "Det finnes ingen gallerier...",
    "galleryAccess": "få tilgang til galleriet",
    "enterPinTitle": "Skriv inn koden din for å få tilgang til galleriet."
  },
  "media": {
    "addToMy": {
      "pictures": "Legg til mine bilder",
      "videos": "Legg til mine videoer",
      "documents": "Legg til mine dokumenter"
    },
    "addedToMy": {
      "pictures": "Lagt til mine bilder",
      "videos": "Lagt til mine videoer",
      "documents": "Lagt til i dokumentene mine"
    },
    "removeFromMy": {
      "pictures": "Fjern fra mine bilder",
      "videos": "Fjern fra mine videoer",
      "documents": "Fjern fra mine dokumenter"
    },
    "removedFromMy": {
      "pictures": "Fjernet fra mine bilder",
      "videos": "Fjernet fra mine videoer",
      "documents": "Fjernet fra mine dokumenter"
    },
    "noImages": "Det er ingen bilder å vise...",
    "noVideos": "Det er ingen videoer å vise...",
    "noDocuments": "Det er ingen dokumenter å vise...",
    "myDocuments": "Mine dokumenter",
    "myGalleries": "Mine gallerier",
    "myImages": "Mine bilder",
    "myVideos": "Mine videoer"
  },
  "meals": {
    "moduleName": "Matplan",
    "eating": "spiser med",
    "noMenu": "har ikke en meny for",
    "noMenuDay": "Det finnes ingen meny for ",
    "theMeal": "måltider",
    "noMeals": "Ingen måltider",
    "noMealsDescription": "Ingen måltider tilgjengelig ...",
    "alreadySignedUp": "Du er allerede påmeldt dette måltidet",
    "alreadySignedOff": "Du er ikke påmeldt dette måltidet",
    "optOut": "Skriv inn koden din for å melde deg av måltidet.",
    "optedOut": "Du er nå avmeldt måltidet.",
    "signUp": "Skriv inn koden din for å registrere deg for måltidet.",
    "signedUp": "Du er nå registrert for måltidet."
  },
  "meeting": {
    "agenda": "Sakliste",
    "agendaPoints": "Sakliste - {amount} punkter",
    "moduleName": "Møter",
    "daysLeft": "tilbake",
    "noAgenda": "Det er ingen elementer på agenda...",
    "suggestionItems": "{amount} forslag",
    "suggestion": "Forslag",
    "suggestions": "Forslag til agenda",
    "moreSuggestions": "Flere forslag",
    "writeSuggestion": "Skriv forslag",
    "suggestionSaved": "Forslaget er lagret",
    "returnToMeeting": "Tilbake til møtet",
    "theMeeting": "møtet",
    "noMeetingsDescription": "Ingen møter å vise ...",
    "alreadySignedUp": "Du er allerede påmeldt dette møtet",
    "toSuggest": "Skriv et forslag til møtet",
    "agendaPointss": "Dagsorden – Én sak",
    "agendaPointss_plural": "Dagsorden – {amount} saker",
    "alreadySignedOff": "Du er ikke påmeldt dette møtet",
    "category": "Kategori",
    "noSuggestionsYet": "Ingen forslag ennå",
    "tts_agenda_point": "Varenummer: { {number} {title}",
    "tts_user_suggestion": "Forslag fra {user} : {suggestion}"
  },
  "modals": {
    "login": "Logg inn",
    "loginText": "Velg deg selv fra listen",
    "isSignedUp": "er påmeldt",
    "allResidentsIn": "Alle borgere i",
    "allEmployeesIn": "Alle ansatte i",
    "save": "Lagre",
    "delete": "slett",
    "wrongPassword": "Feil kode",
    "myPictures": "Bilder av meg",
    "myTags": "Disse bildene jeg har blitt merket på.",
    "returnToPicture": "Tilbake til bildet",
    "whoIsTagged": "Hvem er i bildet",
    "whoIsTaggedText": "Velg personene som er på bildet. Trykk deretter på lagre",
    "documentError": "Dokumentet kunne ikke hentes!",
    "writePassword": "Skriv din kode for å ",
    "writePasswordSuggestion": "skrive forslag til ",
    "writePasswordEdit": "endre på ",
    "writePasswordOptin": "melde deg på ",
    "writePasswordOptout": "melde deg av ",
    "youAreBooking": "Du holder på å booke ",
    "ressourcePurpose": "Hva skal ressursen brukes til?",
    "searchResident": "Søk etter borger",
    "keyboardDelete": "SLETT",
    "keyboardSpace": "Space",
    "logOn": "Logg inn",
    "next": "Neste",
    "skip": "Hopp over",
    "writeYourSuggestion": "Skriv inn ditt forslag",
    "emptyString": "tekst tom",
    "passwordLocked": "Passordet er sperret av sikkerhetsgrunner. Prøv igjen om {amount}",
    "tooManyAttempts": "FOR MANGE FORSØG",
    "tooManyAttemptsTryAgain": "Prøv igjen om {minutes} minutter."
  },
  "news": {
    "moduleName": "Nyheter",
    "noNews": "Ingen nyheter",
    "noNewsDescription": "Ingen nyheter å vise ...",
    "published": "Utgitt: "
  },
  "ourHome": {
    "moduleName": "Hos oss",
    "videoPresentation": "Videopresentasjon",
    "presentation": "Presentasjon",
    "noPresentation": "har ingen presentasjon",
    "galleries": "Gallerier",
    "videos": "Videoer",
    "documents": "Dokumenter",
    "noDocuments": "Det finnes ingen dokumenter",
    "noResidents": "Ingen borgere i",
    "noEmployees": "Ingen ansatte i",
    "residents": "Borgere",
    "employees": "Ansatte",
    "noMeetings": "Det er ingen planlagte møter...",
    "dayLeft": "dag igjen",
    "daysLeft": "dager igjen",
    "iAmTagged": "Disse bildene jeg har blitt merket på"
  },
  "resident": {
    "homeDays": "Hjemmedager",
    "birthdayToday": "har bursdag i dag!",
    "myPictures": "Mine bileder",
    "noVideos": "Det er ingen videoer å vise...",
    "resident": "Borger"
  },
  "scheduleShift": {
    "moduleName": "Tjenesteplan",
    "noShifts": "Det finnes ingen tjenester",
    "noShiftsToday": "Ingen tjenester i dag",
    "options": "Du har tre muligheter",
    "cancel": "avbryt",
    "cancelShift": "Avlys tjenesten",
    "shiftCancelled": "Tjenesten er avlyst",
    "cancelShiftHelpText": "Visningen av tjenesten vil være nedtonet. Du kan angre dette senere.",
    "annullCancelation": "Angre avlysningen",
    "annullCancelationHelpText": "Visningen av tjenesten vil se normal ut igjen.",
    "delete": "slett",
    "deleteShift": "Slett tjenesten",
    "deleteShiftHelpText": "Tjenesten vil bli slettet. Du kan ikke angre dette.",
    "deleteConfirmPreName": "Du holder på å slette ",
    "deleteConfirmPostName": "tjeneste. Er du sikker på at du vil slette denne? Dette kan ikke angres.",
    "confirmDeleteButton": "Bekreft sletting",
    "replace": "Erstatt",
    "swap": "erstatt",
    "replaceShift": "Erstatt tjenesten",
    "replaceShiftChooseText": "Velg den medarbeideren som skal erstatte tjenesten.",
    "replaceShiftHelpText": "Tjenesten kan tildeles en annen medarbeider. Du kan angre dette senere.",
    "replaceWith": "Erstatt med ",
    "returnToScheduleShift": "Tilbake til tjenesteplan",
    "inaccessible": "Utilgjengelig",
    "workingNow": "Hvem er på jobb nå?",
    "workingLater": "Kommer senere",
    "noOneWorkingNow": "Det er ingen på jobb akkurat nå...",
    "noOneComing": "Det kommer ingen senere...",
    "editScheduleShift": "Du kan nå endre tjenesteplanen",
    "theScheduleShift": "Tjenesteplanen",
    "shiftFor": "tjenesten for",
    "cancelText": "annullere",
    "cancelButton": "Anullere",
    "reactivateButton": "Reaktiver",
    "confirmCancelationButton": "Bekreft avbestilling",
    "confirmReactivationButton": "Bekreft reaktivering",
    "editShiftButton": "Rediger tjeneste",
    "editNotAllowed": "Du må være ansatt for å redigere tjenesteplanen. Vennligst tilbakestill skjermen ved å navigere til hovedskjermen og prøv igjen.",
    "notComing": "Kommer ikke",
    "reactivate": "reaktivere"
  },
  "calendar": {
    "moduleName": "Kalender"
  },
  "system": {
    "connectionError": "Tilkoblingsfeil",
    "connectionErrorText": "Systemet forsøker automatisk å koble til igjen ...",
    "connectionErrorHelpText": "Systemet mangler grunnleggende informasjon til arbeid. Du vil bli sendt for å logge inn om 10 sekunder",
    "testConnection": "Test tilkobling",
    "logOut": "Logg ut",
    "menu": "Meny"
  },
  "travelPlan": {
    "moduleName": "Reiseplan"
  },
  "wayfinder": {
    "moduleName": "Finn vei",
    "youAreHere": "Her er du",
    "groundFloor": "Stue",
    "xFloor": "etasje",
    "searchResidents": "Søk etter beboer – trykk her",
    "info": "Info",
    "toilet": "Toalett",
    "searchResult": "Søkeresultat:"
  },
  "weather": {
    "moduleName": "Været",
    "metersPerSecond": "m/s"
  },
  "profileSelect": {
    "header": "Hvem er du?",
    "description": "Velg deg selv fra listen"
  },
  "profileDetails": {
    "header": "Logget inn som",
    "description": "Noen beskrivelse"
  },
  "feedback": {
    "stopRecording": "Stopp opptak",
    "addMessage": "Du kan beskrive feilen du opplever i tekstfeltet nedenfor",
    "message": "Melding",
    "maxCharacters": "Maks 500 tegn"
  },
  "emptyStates": {
    "ACTIVITIES": "Ingen aktiviteter",
    "EXTERNAL_ACTIVITIES": "Ingen eksterne aktiviteter",
    "GALLERY": "Ingen gallerier",
    "NEWS": "Ingen nyheter",
    "BOOKING": "Ingen bookinger",
    "MEETINGS": "Ingen møter",
    "MEAL_PLAN": "Ingen måltider",
    "WORK_SCHEDULE": "Ingen tjenester å vise",
    "SIMPLE_WORK_SCHEDULE": "Ingen tjenester å vise",
    "LATER_WORK_SCHEDULE": "Ingen tjenester å vise",
    "JOURNEY_PLANNER": "Ingen afgange",
    "WEATHER": "Ingen værdata",
    "BOOKING_RESOURCES": "Ingen bookingressurser",
    "OUR_HOME": "Ingenting å vise",
    "SLIDESHOW": "Ingen slideshows"
  },
  "emptyViews": {
    "Activities": "Ingen aktiviteter",
    "Galleries": "Ingen gallerier",
    "News": "Ingen nyheter",
    "Booking": "Ingen ressurser",
    "Meetings": "Ingen møter",
    "MealPlan": "Ingen måltider",
    "WorkSchedule": "Ingen tjenester å vise"
  },
  "rrule": {
    "YEARLY": "Årlig",
    "MONTHLY": "Månedlig",
    "WEEKLY": "Hver uke",
    "DAILY": "Hver dag",
    "HOURLY": "Hver time",
    "MINUTELY": "Hvert minutt",
    "SECONDLY": "Hvert sekund"
  },
  "journeyPlanner": {
    "1Hour": "+1 time",
    "2Hours": "+2 timer",
    "30Minutes": "+30 minutter",
    "newTime": "Ny tid"
  },
  "meetings": {
    "addSuggestionPinTitle": "Skriv inn koden din for å legge til et forslag i møtet",
    "optOut": "Skriv inn koden din for å melde deg av møtet.",
    "optedOut": "Du er nå avregistrert fra møtet.",
    "signUp": "Skriv inn koden din for å bli med i møtet.",
    "signedUp": "Du er nå registrert for møtet."
  },
  "months": {
    "april": "april",
    "august": "august",
    "december": "desember",
    "february": "februar",
    "january": "januar",
    "july": "juli",
    "june": "juni",
    "march": "mars",
    "may": "mai",
    "november": "november",
    "oktober": "oktober",
    "september": "september"
  },
  "workSchedule": {
    "cancel": {
      "confirmation": "Tjenesten er kansellert.",
      "title": "Skriv inn koden din for å avbryte tjenesten for {name}"
    },
    "delete": {
      "confirmation": "Tjenesten er slettet.",
      "title": "Skriv inn koden din for å slette tjenesten for {name}"
    },
    "reactivate": {
      "confirmation": "Tjenesten er reaktivert.",
      "title": "Skriv inn koden din for å aktivere tjenesten på nytt for {name}"
    },
    "replace": {
      "confirmation": "Tjenesten har blitt erstattet.",
      "title": "Skriv inn koden din for å erstatte tjenesten for {name}"
    }
  }
}
